import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { CommonService, SpanishRegulatoryHelperService, TrackingModelService } from '@frontend/promo-homewidget';
import { DsButton } from '@frontend/ui/button';
import { DynamicHtmlDirective, NavigationService, ViewTemplate } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

import { GrayoutStyleDirective } from '../../../../../common/directives/grayout-style.directive';
import { EdsDetails } from '../../eds-models/eds-details';
import { EdsEventData } from '../../eds-models/eds-event-data';
import { PlayerReward } from '../../eds-models/player-reward';
import { EdsService } from '../../eds-service/eds.service';
import { getEdsDetails } from '../../store/eds.selectors';
import { OverlayDialogModal } from '../common/overlayDialogModal';

@Component({
    selector: 'partially-rewarded-result-tile',
    templateUrl: './partially-rewarded-result-tile.component.html',
    styleUrls: ['./partially-rewarded-result-tile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [DynamicHtmlDirective, GrayoutStyleDirective, DsButton],
})
export class PartiallyRewardedResultTileComponent implements OnInit, OnDestroy {
    @Input() rewardContent: PlayerReward;
    @Input() rewardStatus: boolean;
    @Input() currentlyAchievedPrizeModules: boolean;
    @Input() eventData: EdsEventData;
    @Input() title: string;

    clientContent: ViewTemplate;
    edsDetails: EdsDetails;
    private readonly destroy$ = new Subject<void>();

    constructor(
        private commonService: CommonService,
        private spanishRegulatoryHelperService: SpanishRegulatoryHelperService,
        private edsService: EdsService,
        private overlayDialogModal: OverlayDialogModal,
        private trackingModelService: TrackingModelService,
        private store: Store<{ edsModuleData: EdsDetails }>,
        private navService: NavigationService,
    ) {}
    ngOnInit(): void {
        this.store
            .select(getEdsDetails)
            .pipe(takeUntil(this.destroy$))
            .subscribe((edsDetails: EdsDetails) => {
                this.edsDetails = edsDetails;
            });
        this.edsService.getContent?.pipe(takeUntil(this.destroy$)).subscribe((response) => {
            this.clientContent = response;
        });
    }

    checkButtonClick() {
        if (this.rewardContent?.resultPrize?.checkPromoLink?.url) {
            this.navService.goTo(this.rewardContent.resultPrize.checkPromoLink.url);
        } else {
            this.commonService.goToOverviewPage();
        }
        this.trackingModelService.submitTracking({
            CategoryEvent: 'Promo Hub',
            LabelEvent: 'player activity promotions eds',
            ActionEvent: 'click',
            PositionEvent: this.title,
            LocationEvent: 'currently achieved',
            EventDetails: 'use',
            URLClicked: this.rewardContent?.resultPrize?.checkPromoLink?.url,
        });
        this.trackingModelService.submitTracking({
            CategoryEvent: 'Promo Hub',
            LabelEvent: 'player activity promotions eds',
            ActionEvent: 'load',
            PositionEvent: this.title + '- claimed',
            LocationEvent: 'My Progress',
            EventDetails: 'reward claim confirmation',
            URLClicked: this.rewardContent?.resultPrize?.checkPromoLink?.url,
        });
    }

    chooseReward(title: string) {
        if (this.spanishRegulatoryHelperService.isRiskyPlayer) {
            this.spanishRegulatoryHelperService.showNonComplianceErrorMessage();
            return;
        }
        this.overlayDialogModal.openDialogModal(
            this.edsDetails?.edsMetadata?.offerId,
            this.eventData,
            this.clientContent,
            this.edsDetails?.edsContent,
        );
        this.trackingModelService.submitTracking({
            CategoryEvent: 'Promo Hub',
            LabelEvent: 'player activity promotions eds',
            ActionEvent: 'click',
            PositionEvent: title,
            LocationEvent: 'currently achieved',
            EventDetails: 'choose',
            URLClicked: 'not applicable',
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
